import React from 'react';
// @ts-ignore
import DHTypography from "@digital-hig/mui/Typography";
// @ts-ignore
import DHTextField from "@digital-hig/mui/TextField";
import { ErrorMessage } from './ErrorMessage';

interface FormFieldProps {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: () => void;
  error: boolean;
  errorMessage: string;
  showError: boolean;
  disabled?: boolean;
  maxLength?: number;
}

export const FormField: React.FC<FormFieldProps> = ({
  label,
  value,
  onChange,
  onBlur,
  error,
  errorMessage,
  showError,
  disabled = false,
  maxLength
}) => {
  return (
    <>
      <DHTypography 
        variant="body-copy-medium"
        className="dhig-typography-body-copy-medium dhig-color-text-primary"
        style={{
          fontFamily: 'Artifakt Element, sans-serif',
          fontWeight: 400,
          fontSize: '12px',
          lineHeight: '16px',
          letterSpacing: '0%',
          verticalAlign: 'bottom',
          marginBottom: '8px'
        }}
      >
        {label}
      </DHTypography>
      <DHTextField
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        variant="outlined"
        error={error}
        helperText=""
        disabled={disabled}
        inputProps={maxLength ? { maxLength } : undefined}
        sx={{
          width: '100%',
          maxWidth: '410px',
          height: '40px',
          opacity: 1,
          '& .MuiInputBase-root': {
            height: '40px',
            paddingTop: '8px',
            paddingRight: '12px',
            paddingBottom: '8px',
            paddingLeft: '8px'
          },
          '& .MuiInputBase-input': {
            fontFamily: 'Artifakt Element, sans-serif !important',
            fontWeight: '600 !important',
            fontSize: '16px !important',
            lineHeight: '20px !important',
            letterSpacing: '0% !important',
            verticalAlign: 'middle !important',
            padding: '0 !important'
          },
          '&.Mui-disabled': {
            backgroundColor: 'white !important'
          },
          '& .MuiInputBase-root.Mui-disabled': {
            backgroundColor: 'white !important',
            color: 'rgba(0, 0, 0, 0.38) !important'
          }
        }}
      />
      <ErrorMessage show={showError} message={errorMessage} />
    </>
  );
}; 